export const MAX_FILE_SIZE_BYTES = 10_000_000; // 10 MB
